<template>
  <thead class="[&_tr]:border-b">
    <slot />
  </thead>
</template>
